import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "../../base.component";
import { NewsService, News } from "../../../services/news.service";
import { PaginationService } from "app/services/pagination.service";
import { NotificationsService } from "angular2-notifications";
// import {  } from "angular2-notifications";

@Component({
	selector: 'app-news',
	templateUrl: './news.component.html',
	styleUrls: ['./news.component.less']
})
export class NewsComponent extends BaseComponent implements OnInit {

	news: News[];
	pager: any = {};
	pagedItems: any[];

	constructor(
		public newsService: NewsService,
		private paginationService: PaginationService,
		private notificationsService: NotificationsService
	) {
		super();
	}

	ngOnInit() {
		this.newsService.getAllNews().subscribe(news => {
			this.news = news.sort((a, b) => {
                if (a.created_at == b.created_at) {
                    return 0;
                }
                return a.created_at > b.created_at ? -1 : 1;
            });
			this.setPage(1);
		});
	}

	onDeleteClick(id)
	{	
		var self = this;
		if(id){
			if(confirm('Are you sure?'))
			{	
				this.newsService.deleteNews(id).then(function(){
					// alert('News has been succesfully deleted');
					self.notificationsService.error('Deleted','1 news deleted');
				}).catch(function(e){
					console.log('There is an error. '+e.message);
				}) ;
			}
		}
	}

	setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.news.length, page);

        // get current page of items
        this.pagedItems = this.news.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/news/news/news.component.ts